import script from "./journeys.vue?vue&type=script&setup=true&lang=js"
export * from "./journeys.vue?vue&type=script&setup=true&lang=js"

import "./journeys.vue?vue&type=style&index=0&id=a29c5916&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a29c5916"]])

export default __exports__